import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { hasThreatIntelV2Access } from 'garaje/utils/threat-intel-access';

export default class CommunicationsAlertsRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  beforeModel(): void {
    // Two paths grant access:
    //  - hasThreatIntelV2Access — v2 iframe path (composite: v2 split AND (billing entitlement
    //    OR ent-limited split)); see utils/threat-intel-access.ts.
    //  - `emno-threat-intelligence-web` — v1 RRC path; when on, the {{else}} branch in
    //    template.hbs renders the RRC dashboard via injectComponent.
    const hasV2Access = hasThreatIntelV2Access(this.featureFlags, this.state);
    const hasThreatIntelV1 = this.featureFlags.isEnabled('emno-threat-intelligence-web');
    if (!hasV2Access && !hasThreatIntelV1) {
      void this.router.transitionTo('communications.message-log.new');
    }
  }
}
